import { Component, Input } from '@angular/core';

import { ApiEditPeriod } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-edit-period',
    templateUrl: './edit-period.component.html',
    standalone: false
})
export class EditPeriodComponent {

    @Input()
    public period: ApiEditPeriod;

    public get daysLeft(): number {

        if (!this.period.to) {
            return null;
        }

        const diffInMilliseconds = this.period.to.getTime() - new Date().getTime();

        return Math.round(diffInMilliseconds / (1000 * 60 * 60 * 24));
    }
}
